import { useTranslation } from "react-i18next";
import AuthoringPage from "../AuthoringPage";
import ArtifactForm from "./ArtifactForm";

/** `/workflows/new/artifact`: the artifact form for a new artifact (AU-5). */
export default function NewArtifactPage() {
  const { t } = useTranslation();
  return (
    <AuthoringPage title={t("authoring.artifact.newTitle")} intro={t("authoring.artifact.intro")}>
      {(projectId, options) => <ArtifactForm projectId={projectId} options={options} base={null} />}
    </AuthoringPage>
  );
}
